"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'index',
  data: function data() {
    return {
      constants: this.$constants,
      loading: false,
      templateRadio: '',
      dialogFormVisible: false,
      tableData: [],
      artFrom: {
        page: 1,
        limit: 20,
        nickname: '',
        phone: ''
      },
      total: 0,
      timeVal: ''
    };
  },
  methods: {
    //重置
    handleReset: function handleReset() {
      this.artFrom.nickname = '';
      this.artFrom.phone = '';
      this.tableList();
    },
    getTemplateRow: function getTemplateRow(row) {
      this.dialogFormVisible = false;
      this.$emit('upImgUid', row);
    },
    tableList: function tableList() {
      var _this = this;
      this.loading = true;
      (0, _user.userListApi)(this.artFrom).then(function (data) {
        _this.tableData = data.list;
        _this.total = data.total;
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    //切换显示条数
    sizeChange: function sizeChange(index) {
      this.artFrom.limit = index;
      this.tableList();
    },
    //切换页数
    pageChange: function pageChange(index) {
      this.artFrom.page = index;
      this.tableList();
    },
    search: function search() {
      this.artFrom.page = 1;
      this.tableList();
    },
    cancel: function cancel() {
      this.artFrom = {
        page: 1,
        limit: 20,
        nickname: '',
        phone: ''
      };
      this.timeVal = '';
      this.templateRadio = '';
    }
  }
};